import moment from "moment";
import React, { useMemo, useState } from "react";
import { Badge, Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import ReactSelect from "react-select";
import { useTable, useGlobalFilter, useSortBy } from "react-table";
import swal from "sweetalert";
import {
  getAssesmentsCompleted,
  SaveAssesment,
  updateAssesmentSharedUsers,
} from "../../services/AssesmentService";
import { getApplicationUsers } from "../../services/UserService";
import PageTitle from "../layouts/PageTitle";
import { GlobalFilter } from "../components/table/FilteringTable/GlobalFilter";
import { getModifiedData } from "../../utils/completedUtils";
import { useSelector } from "react-redux";
import { isViewAsActive } from "../../services/ViewAsService";

export const AssesmentCompleted = () => {
  const authUser = useSelector((state) => state.auth.auth);
  const viewOnly = isViewAsActive(authUser);
  const [assesments, setAssesments] = React.useState([]);
  const [users, setUsers] = React.useState([]);
  const [addCard, setAddCard] = React.useState(false);
  const columns = useMemo(
    () => [
      {
        // Mongo id (+ old-portal id for migrated SIRS reports). The accessor
        // joins both so the global search box matches either.
        Header: "ID",
        id: "assessmentId",
        accessor: (row) =>
          [row.id || row._id, row.legacyId].filter(Boolean).join(" "),
        Cell: ({ row }) => (
          <span style={{ fontFamily: "monospace", fontSize: "0.85em" }}>
            {String(row.original.id || row.original._id || "")}
            {row.original.legacyId && (
              <div className="text-muted" title="Old-portal report ID">
                legacy {row.original.legacyId}
              </div>
            )}
          </span>
        ),
      },
      {
        Header: "Name",
        id: "name",
        accessor: (row) => (row.assesmentUser && row.assesmentUser.name) || "",
        Cell: ({ value }) => <span>{value}</span>,
      },
      {
        Header: "Template",
        id: "template",
        accessor: (row) =>
          (row.assessmentTemplate && row.assessmentTemplate.name) || "",
        Cell: ({ value }) => <span>{value}</span>,
      },
      {
        Header: "Agency",
        id: "agency",
        accessor: (row) => row.agency || "",
        Cell: ({ value }) => <span>{value}</span>,
      },
      {
        Header: "Country",
        id: "country",
        accessor: (row) => row.country || "",
        Cell: ({ value }) => <span>{value}</span>,
      },
      {
        Header: "Location",
        id: "location",
        accessor: (row) =>
          [row.premisesName, row.city]
            .filter((v) => v && v !== "-")
            .join(", ") || "",
        Cell: ({ value }) => <span>{value}</span>,
      },
      {
        Header: "Completion Date",
        accessor: "assessmentDate",
        Cell: ({ value }) =>
          value ? <span>{moment(value).format("DD-MM-YYYY")}</span> : "",
      },
      {
        Header: "Action",
        accessor: "id",
        Cell: (data) => {
          const { value } = data;
          return (
            <span>
              <Badge variant="success color-white">
                {data.row.original &&
                  data.row.original.assessmentTemplate &&
                  data.row.original.assessmentTemplate.ID === "1" && (
                    <div className="d-flex">
                      <Link
                        style={{ color: "#fff" }}
                        to={{
                          pathname: `/assesmentSummary/${data.row.original.id}`,
                          state: { assesment: data.row.original },
                        }}
                      >
                        View
                      </Link>
                    </div>
                  )}
                {data.row.original &&
                  data.row.original.assessmentTemplate &&
                  data.row.original.assessmentTemplate.ID === "2" && (
                    <div className="d-flex">
                      <Link
                        style={{ color: "#fff" }}
                        to={{
                          pathname: `/assesmentSummary2/${data.row.original.assessmentTemplate.ID}/${data.row.original.id}`,
                          state: { assesment: data.row.original },
                        }}
                      >
                        View
                      </Link>
                    </div>
                  )}
                {data.row.original &&
                  data.row.original.assessmentTemplate &&
                  data.row.original.assessmentTemplate.ID === "3" && (
                    <div className="d-flex">
                      <Link
                        style={{ color: "#fff" }}
                        to={{
                          pathname: `/assesmentSummary3/${data.row.original.assessmentTemplate.ID}/${data.row.original.id}`,
                          state: { assesment: data.row.original },
                        }}
                      >
                        View
                      </Link>
                    </div>
                  )}
                {data.row.original &&
                  data.row.original.assessmentTemplate &&
                  data.row.original.assessmentTemplate.ID === "5" && (
                    <div className="d-flex">
                      <Link
                        style={{ color: "#fff" }}
                        to={{
                          pathname: `/assesmentSummary5/${data.row.original.assessmentTemplate.ID}/${data.row.original.id}`,
                          state: { assesment: data.row.original },
                        }}
                      >
                        View
                      </Link>
                    </div>
                  )}
                {data.row.original &&
                  data.row.original.assessmentTemplate &&
                  data.row.original.assessmentTemplate.ID === "6" && (
                    <div className="d-flex">
                      <Link
                        style={{ color: "#fff" }}
                        to={{
                          pathname: `/assesmentSummary6/${data.row.original.assessmentTemplate.ID}/${data.row.original.id}`,
                          state: { assesment: data.row.original },
                        }}
                      >
                        View
                      </Link>
                    </div>
                  )}
                {data.row.original &&
                  data.row.original.assessmentTemplate &&
                  data.row.original.assessmentTemplate.ID === "7" && (
                    <div className="d-flex">
                      <Link
                        style={{ color: "#fff" }}
                        to={{
                          pathname: `/assesmentSummary7/${data.row.original.assessmentTemplate.ID}/${data.row.original.id}`,
                          state: { assesment: data.row.original },
                        }}
                      >
                        View
                      </Link>
                    </div>
                  )}
                {data.row.original &&
                  data.row.original.assessmentTemplate &&
                  data.row.original.assessmentTemplate.ID === "8" && (
                    <div className="d-flex">
                      <Link
                        style={{ color: "#fff" }}
                        to={{
                          pathname: `/assesmentSummary8/${data.row.original.assessmentTemplate.ID}/${data.row.original.id}`,
                          state: { assesment: data.row.original },
                        }}
                      >
                        View
                      </Link>
                    </div>
                  )}
                {data.row.original &&
                  data.row.original.assessmentTemplate &&
                  data.row.original.assessmentTemplate.ID === "9" && (
                    <div className="d-flex">
                      <Link
                        style={{ color: "#fff" }}
                        to={{
                          pathname: `/assesmentSummary9/${data.row.original.assessmentTemplate.ID}/${data.row.original.id}`,
                          state: { assesment: data.row.original },
                        }}
                      >
                        View
                      </Link>
                    </div>
                  )}
                  {data.row.original &&
                  data.row.original.assessmentTemplate &&
                  data.row.original.assessmentTemplate.ID === "10" && (
                    <div className="d-flex">
                      <Link
                        style={{ color: "#fff" }}
                        to={{
                          pathname: `/assesmentSummary10/${data.row.original.assessmentTemplate.ID}/${data.row.original.id}`,
                          state: { assesment: data.row.original },
                        }}
                      >
                        View
                      </Link>
                    </div>
                  )}
                  {data.row.original &&
                  data.row.original.assessmentTemplate &&
                  data.row.original.assessmentTemplate.ID === "11" && (
                    <div className="d-flex">
                      <Link
                        style={{ color: "#fff" }}
                        to={{
                          pathname: `/assesmentSummary11/${data.row.original.assessmentTemplate.ID}/${data.row.original.id}`,
                          state: { assesment: data.row.original },
                        }}
                      >
                        View
                      </Link>
                    </div>
                  )}
                  {data.row.original &&
                  data.row.original.assessmentTemplate &&
                  data.row.original.assessmentTemplate.ID === "12" && (
                    <div className="d-flex">
                      <Link
                        style={{ color: "#fff" }}
                        to={{
                          pathname: `/assesmentSummary12/${data.row.original.assessmentTemplate.ID}/${data.row.original.id}`,
                          state: { assesment: data.row.original },
                        }}
                      >
                        View
                      </Link>
                    </div>
                  )}
                  {data.row.original &&
                  data.row.original.assessmentTemplate &&
                  data.row.original.assessmentTemplate.ID === "13" && (
                    <div className="d-flex">
                      <Link
                        style={{ color: "#fff" }}
                        to={{
                          pathname: `/assesmentSummary13/${data.row.original.assessmentTemplate.ID}/${data.row.original.id}`,
                          state: { assesment: data.row.original },
                        }}
                      >
                        View
                      </Link>
                    </div>
                  )}
                  {data.row.original &&
                  data.row.original.assessmentTemplate &&
                  data.row.original.assessmentTemplate.ID === "14" && (
                    <div className="d-flex">
                      <Link
                        style={{ color: "#fff" }}
                        to={{
                          pathname: `/assesmentSummary14/${data.row.original.assessmentTemplate.ID}/${data.row.original.id}`,
                          state: { assesment: data.row.original },
                        }}
                      >
                        View
                      </Link>
                    </div>
                  )}
              </Badge>
              &nbsp;
              {!viewOnly && (
                <Badge
                  onClick={(e) => handleEditClick(e, value)}
                  variant="primary color-white pointer"
                >
                  Edit Ownership
                </Badge>
              )}
            </span>
          );
        },
      },
    ],
    [assesments]
  );
  const data = useMemo(() => [...assesments], [assesments]);

  const getAssesmentCompleted = () => {
    getAssesmentsCompleted().then((data) => {
      setAssesments(data);
    });
  };

  React.useEffect(() => {
    getAssesmentCompleted();
    getApplicationUsers().then((res) => setUsers(res.results));
  }, []);

  const tableInstance = useTable(
    {
      columns,
      data: assesments,
    },
    useGlobalFilter,
    useSortBy
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    footerGroups,
    rows,
    prepareRow,
    setGlobalFilter,
    state,
  } = tableInstance;

  const { globalFilter } = state;

  const [editAssesmentForm, setEditAssesmentForm] = React.useState({});
  const [editContentId, setEditContentId] = React.useState(undefined);
  const [sharedUsersForm, setSharedUsersForm] = React.useState([]);
  const [shareUserToAdd, setShareUserToAdd] = React.useState(null);
  const [savingShared, setSavingShared] = React.useState(false);

  const handleSelectChange = (field, value) => {
    const newFormData = { ...editAssesmentForm };
    newFormData[field] = value;
    setEditAssesmentForm(newFormData);
  };

  // resolve a shared-user id to a display name using the loaded users list
  const resolveUser = (userId) => {
    const u = users.find((item) => item.id === userId || item._id === userId);
    return u || { id: userId, name: "Unknown user" };
  };

  const handleEditClick = (event, value) => {
    const content = assesments.find((assesment) => assesment.id === value);
    event.preventDefault();
    setEditContentId(content.id);
    setEditAssesmentForm(content);
    const existing = (content.sharedUsers || []).map((s) => {
      const uid = (s.user && (s.user.id || s.user._id || s.user)) || s.user;
      const u = resolveUser(uid);
      return {
        user: uid,
        name: u.name,
        canView: !!s.canView,
        canEdit: !!s.canEdit,
      };
    });
    setSharedUsersForm(existing);
    setShareUserToAdd(null);
    setAddCard(true);
  };

  const handleAddShareUser = () => {
    if (!shareUserToAdd) return;
    const uid = shareUserToAdd.id || shareUserToAdd._id;
    if (sharedUsersForm.some((s) => s.user === uid)) {
      swal("Already added", "That user is already shared.", "info");
      return;
    }
    setSharedUsersForm([
      ...sharedUsersForm,
      { user: uid, name: shareUserToAdd.name, canView: true, canEdit: false },
    ]);
    setShareUserToAdd(null);
  };

  const handleRemoveShareUser = (uid) => {
    setSharedUsersForm(sharedUsersForm.filter((s) => s.user !== uid));
  };

  const toggleSharePermission = (uid, field) => {
    setSharedUsersForm(
      sharedUsersForm.map((s) =>
        s.user === uid ? { ...s, [field]: !s[field] } : s
      )
    );
  };

  const handleSaveSharedUsers = () => {
    setSavingShared(true);
    const payload = sharedUsersForm.map((s) => ({
      user: s.user,
      canView: s.canView,
      canEdit: s.canEdit,
    }));
    updateAssesmentSharedUsers(editContentId, payload)
      .then(() => {
        swal("Success", "Shared users updated", "success");
        getAssesmentCompleted();
      })
      .catch((err) => {
        swal(
          (err.response && err.response.data && err.response.data.message) ||
            "Could not update shared users",
          { icon: "error" }
        );
      })
      .finally(() => setSavingShared(false));
  };

  const handleupdatedFormSubmit = (e) => {
    e.preventDefault();
    const body = {
      ...editAssesmentForm,
      assesmentUser: editAssesmentForm.assesmentUser.id,
      assessmentTemplate: editAssesmentForm.assessmentTemplate._id,
    };
    SaveAssesment(editContentId, body).then(() => {
      setAddCard(false);
      swal("Success", "Ownership Updated successfully", "success");
      getAssesmentCompleted();
    });
  };

  return (
    <>
      <PageTitle activeMenu="Assesment Completed" motherMenu="Assesment" />
      <Modal className="modal fade" show={addCard} onHide={setAddCard}>
        <div className="" role="document">
          <div className="">
            <form>
              <div className="modal-header">
                <h4 className="modal-title fs-20">Edit Assessment</h4>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setAddCard(false)}
                  data-dismiss="modal"
                >
                  <span></span>
                </button>
              </div>
              <div className="modal-body">
                <i
                  className="flaticon-cancel-12 close"
                  data-dismiss="modal"
                ></i>
                <div className="add-contact-box">
                  <div className="add-contact-content">
                    <div className="form-group mb-3">
                      <label className="text-black font-w500">User</label>
                      <div className="contact-name">
                        <ReactSelect
                          name="agency"
                          fieldName="agency"
                          onChange={(e) =>
                            handleSelectChange("assesmentUser", e)
                          }
                          options={users}
                          value={editAssesmentForm.assesmentUser}
                          getOptionLabel={(option) => option.name}
                          getOptionValue={(option) => option.id}
                          style={{
                            lineHeight: "40px",
                            color: "#7e7e7e",
                            paddingLeft: " 15px",
                          }}
                        />
                        <span className="validation-text"></span>
                      </div>
                    </div>

                    <hr />
                    <div className="form-group mb-2">
                      <label className="text-black font-w500">
                        Shared Users
                      </label>
                      {sharedUsersForm.length > 0 ? (
                        <ul className="list-group mb-2">
                          {sharedUsersForm.map((s) => (
                            <li
                              key={s.user}
                              className="list-group-item d-flex justify-content-between align-items-center flex-wrap"
                            >
                              <span style={{ minWidth: "140px" }}>
                                {s.name}
                              </span>
                              <span className="d-flex align-items-center">
                                <label className="me-2 mb-0">
                                  <input
                                    type="checkbox"
                                    checked={s.canView}
                                    onChange={() =>
                                      toggleSharePermission(s.user, "canView")
                                    }
                                  />{" "}
                                  View
                                </label>
                                <label className="me-3 mb-0">
                                  <input
                                    type="checkbox"
                                    checked={s.canEdit}
                                    onChange={() =>
                                      toggleSharePermission(s.user, "canEdit")
                                    }
                                  />{" "}
                                  Edit
                                </label>
                                <button
                                  type="button"
                                  className="btn btn-danger btn-xs sharp"
                                  title="Remove"
                                  onClick={() => handleRemoveShareUser(s.user)}
                                >
                                  <i className="fa fa-trash"></i>
                                </button>
                              </span>
                            </li>
                          ))}
                        </ul>
                      ) : (
                        <p className="text-muted mb-2">
                          Not shared with anyone yet.
                        </p>
                      )}
                      <div className="d-flex align-items-center">
                        <div style={{ flexGrow: 1, marginRight: "8px" }}>
                          <ReactSelect
                            placeholder="Add user to share…"
                            onChange={(e) => setShareUserToAdd(e)}
                            options={users}
                            value={shareUserToAdd}
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.id}
                          />
                        </div>
                        <button
                          type="button"
                          className="btn btn-secondary"
                          onClick={handleAddShareUser}
                        >
                          Add
                        </button>
                      </div>
                      <button
                        type="button"
                        className="btn btn-primary mt-3"
                        onClick={handleSaveSharedUsers}
                        disabled={savingShared}
                      >
                        {savingShared ? "Saving…" : "Save Shared Users"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="submit"
                  className="btn btn-primary"
                  onClick={handleupdatedFormSubmit}
                >
                  Add
                </button>
                <button
                  type="button"
                  onClick={() => setAddCard(false)}
                  className="btn btn-danger"
                >
                  {" "}
                  <i className="flaticon-delete-1"></i> Discard
                </button>
              </div>
            </form>
          </div>
        </div>
      </Modal>
      <div className="card">
        <div className="card-header">
          <h4 className="card-title">Assesment Completed</h4>
        </div>
        <div className="card-body">
          <div className="table-responsive">
            <div className="dataTables_wrapper">
              <GlobalFilter filter={globalFilter} setFilter={setGlobalFilter} />
              {assesments && assesments.length > 0 ? (
                <table {...getTableProps()} className="table dataTable display">
                  <thead>
                    {headerGroups.map((headerGroup) => (
                      <tr {...headerGroup.getHeaderGroupProps()}>
                        {headerGroup.headers.map((column) => (
                          <th {...column.getHeaderProps()}>
                            {column.render("Header")}
                            <span className="ml-1">
                              {column.isSorted ? (
                                column.isSortedDesc ? (
                                  <i className="fa fa-arrow-down" />
                                ) : (
                                  <i className="fa fa-arrow-up" />
                                )
                              ) : (
                                ""
                              )}
                            </span>
                          </th>
                        ))}
                      </tr>
                    ))}
                  </thead>
                  <tbody {...getTableBodyProps()}>
                    {rows.map((row) => {
                      prepareRow(row);
                      return (
                        <tr {...row.getRowProps()}>
                          {row.cells.map((cell) => {
                            return (
                              <td {...cell.getCellProps()}>
                                {" "}
                                {cell.render("Cell")}{" "}
                              </td>
                            );
                          })}
                        </tr>
                      );
                    })}
                  </tbody>
                  {/* This is only for footer if u require */}
                  <tfoot>
                    {footerGroups.map((footerGroup) => (
                      <tr {...footerGroup.getFooterGroupProps()}>
                        {footerGroup.headers.map((column) => (
                          <td {...column.getFooterProps()}>
                            {column.render("Footer")}
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tfoot>
                </table>
              ) : (
                "No data found"
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default AssesmentCompleted;
